import Menu from './Menu';
export default Menu;
//# sourceMappingURL=index.js.map